import React from 'react';
import Layout from '../components/layout';

export default class Home extends React.Component {
  render() {
    return (
      <Layout title="Home">
        <div>
          <h2>Home Page content</h2>          
        </div>
      </Layout>
    );
  }
}